import { Component, OnInit, Input } from '@angular/core';
import { HtmlParser } from '@angular/compiler';

@Component({
    selector: 'app-help',
    templateUrl: './help.component.html',
    standalone: false
})
export class HelpComponent implements OnInit {

  @Input() helpText: HtmlParser;

  constructor() { }

  ngOnInit(): void { }

}
